import interactionParserUtils from './InteractionParserUtils';
import constants from '../../../Constants';

const uploadParser = {
    parse(interactionNode, language, defaultLanguage) {
        const prompt = interactionParserUtils.getPrompt(interactionNode, language, defaultLanguage);

        const supportedFileExtensions = interactionNode.getAttribute(constants.supportedFileExtensionsAttr) || '*';
        const extraResponseDeclarations = [
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: 'fileClientUploadTime',
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: 'fileName',
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: 'fileType',
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: 'fileSize',
            },
        ];

        const variant = interactionNode.getAttribute(constants.variantAttr);

        return {
            extraResponseDeclarations,
            prompt,
            supportedFileExtensions,
            variant,
        };
    },
};

export default uploadParser;
